import React, { useEffect, useState, useCallback, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled, { createGlobalStyle, keyframes } from "styled-components";
import NewOffersSwiper from "../components/NewOffersSwiper";
// Import Swiper for background image slider
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import { Autoplay, EffectFade } from "swiper/modules";
import icon from "../images/MATCHING.png";
import iconMain from "../images/navLogo.png";
import TrashXmarkIcon from "../images/trash-xmark.svg";
import thumbsup from "../images/thumbsup.svg";
import ChevronLeftIcon from "../images/chevron-left-outlined-rounded.svg";
import ChevronRightIcon from "../images/chevron-right-outlined-rounded.svg";
import { useAuth } from "../context/AuthContext";
import { useFlow } from "../context/FlowContext";
import { authFetch } from "../utils/authFetch";
import { BASE_URL } from "../utils/config";
import { useTranslation } from "react-i18next";
import MyProperties from "../pages/MyProperties";
import ukFlag from "../images/uk-flag.png";
import itFlag from "../images/italy.png";
import frFlag from "../images/france.png";
import deFlag from "../images/germany.png";
import background1 from "../images/1.png";
import background2 from "../images/2.png";
import background3 from "../images/3.png";
import background4 from "../images/4.png";
import background5 from "../images/5.png";
import background6 from "../images/6.png";
import background7 from "../images/7.png";
import background8 from "../images/8.png";
import background9 from "../images/9.png";
import background10 from "../images/10.png";
import background11 from "../images/11.png";
import background12 from "../images/12.png";
import background13 from "../images/13.png";
import background14 from "../images/14.png";
import background15 from "../images/15.png";
import background16 from "../images/16.png";
import background17 from "../images/17.png";
import background18 from "../images/18.png";
import background19 from "../images/19.png";
import background20 from "../images/20.png";
import background21 from "../images/21.png";
import background22 from "../images/22.png";
import background23 from "../images/23.png";
import background24 from "../images/24.png";
import OfferEn from "../images/OFFER_EN.png";
import OfferIt from "../images/OFFER_IT.png";
import OfferFr from "../images/OFFER_FR.png";
import OfferDe from "../images/OFFER_DE.png";
import SearchEn from "../images/SEARCH_EN.png";
import SearchIt from "../images/SEARCH_IT.png";
import SearchFr from "../images/SEARCH_FR.png";
import SearchDe from "../images/SEARCH_DE.png";
import FreeRegEn from "../images/REGISTR_EN.png";
import FreeRegIt from "../images/REGISTR_IT.png";
import FreeRegFr from "../images/REGISTR_FR.png";
import apartmentImage from "../images/sponer.svg";
import MeterIcon from "../images/meter.png";
import BedroomsIcon from "../images/bedrooms.png";
import UnitsIcon from "../images/units.png";
import PriceIcon from "../images/price.png";
import SearchIcon from "../images/search.svg";
import AddressIcon from "../images/address.png";

import FreeRegDe from "../images/REGISTR_DE.png";
import { Zoom } from "react-toastify";


const ShadeGlobalStyle = createGlobalStyle`
  nav, footer {
    filter: blur(0.8px) brightness(0.9);
    overflow: hidden;
  }
`;
const CombinedDropdownContent = styled.div`
  position: absolute;
  top: 100%; /* Position right below the CombinedLoginLanguage container */
  right: 0;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  min-width: 140px; /* Adjust width as needed */
  display: ${(props) => (props.$isOpen ? "block" : "none")};
  padding: 5px 0;
  z-index: 10; /* Ensure it's above other elements */
  cursor: pointer;
`;

const TopRightControls = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 2;

  @media (max-width: 576px) {
    top: 10px;
    right: 10px;
  }
`;

const LanguageVisual = styled.div`
  display: flex;
  align-items: center;
  gap: 3px; /* Very small gap for condensed look */
  font-size: 0.8em; /* Smaller font for language symbol relative to Login text */
  color: #666; /* Slightly muted color for language symbol */
  cursor: pointer;
`;

const FlagIcon = styled.img`
  width: 16px; /* Even smaller flag icon */
  height: 12px;
  border: 1px solid #eee;
  object-fit: cover;
`;

const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 15px;
  cursor: pointer;

  font-size: clamp(0.8rem, 1.5vw, 1rem);
  &:hover {
    background-color: #f0f0f0;
  }
`;

const DropdownLinkItem = styled(Link)`
  display: block;
  padding: 5px 10px; /* Adjusted padding for a larger button */
  text-decoration: none;
  color: #29b185; /* Green text color */
  background-color: #f9f9f9; /* Light background color */
  border: 1px solid #29b185; /* Green border */
  border-radius: 7px; /* Significantly rounded corners */
  cursor: pointer;
`;

const BackgroundWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh; /* Use min-height to ensure it covers the viewport */
  overflow: hidden;
`;

const SponsorCard = styled.div`
  margin: 5px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  min-height: 160px;
  max-height: 280px;
  height: auto;
  width: 240px; /* Match PropertyCard */
  box-shadow: 0px 1px 3px 1px #00000026;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;
  transition:
    transform 0.2s,
    box-shadow 0.2s;
  padding: 0;
  position: relative;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 767px) {
    width: calc(100% - 20px);
    max-width: 100%;
    margin: 10px auto;
  }

  @media (min-width: 2560px) {
    width: 300px; /* Match PropertyCard */
  }
  @media (min-width: 3840px) {
    width: 380px; /* Match PropertyCard */
  }
`;

const SponsorImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: fit-content;
  background-color: #ddd;
  border-radius: 4px;
  overflow: hidden;
  box-sizing: border-box;
  display: block;
  padding: 0;
  flex-shrink: 0;

  @media (max-width: 767px) {
    height: 180px;
  }

  @media (max-width: 576px) {
    height: 160px;
  }
`;

const SponsorImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  border-radius: 4px;
  object-fit: contain;
  object-position: center;
`;

const PageBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%; /* Covers the full height of BackgroundWrapper */
  z-index: 0;
  pointer-events: none;
  filter: blur(1px) brightness(0.9);
  overflow: hidden;
`;

const HomeContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f7fa;
  padding: 20px; /* Base padding */
  box-sizing: border-box;
  padding-top: 0; /* Keep original padding-top: 0 */

  @media (max-width: 768px) {
    padding: 10px; /* Reduced padding on tablets */
    padding-top: 0;
  }
  @media (max-width: 576px) {
    padding: 5px; /* Even less padding on mobile */
    padding-top: 0;
  }
`;

// The main overlay containing Left and Right Panels
const ContentOverlay = styled.div`
  display: flex;
  width: 100%; /* Responsive width, taking most of parent */
  max-width: 1200px; /* Max width for large screens */
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
  height: clamp(
    550px,
    70vh,
    650px
  ); /* Use height with clamp for consistent desktop height */
  z-index: 1;
  border: 2px solid black;
  box-sizing: border-box;
  margin: auto; /* Center horizontally */

  /* Large screens (1600px and above) */
  @media (min-width: 1600px) {
    max-width: 1500px;
  }

  /* Extra large screens (2000px and above) */
  @media (min-width: 2000px) {
    max-width: 1800px;
    height: clamp(650px, 75vh, 800px);
  }

  /* Ultra wide screens (2400px and above) */
  @media (min-width: 2400px) {
    max-width: 2200px;
    height: clamp(700px, 75vh, 900px);
  }

  @media (min-width: 3840px) {
    max-width: 3000px;
    height: clamp(750px, 75vh, 1000px);
  }

  @media (max-width: 992px) {
    /* Tablet and smaller */
    flex-direction: column; /* Stack panels vertically */
    width: 90%; /* Adjust width for stacked layout */
    height: auto; /* Allow height to shrink when stacked */
    min-height: auto; /* Ensure it can shrink */
  }

  @media (max-width: 576px) {
    /* Mobile */
    width: 98%; /* Almost full width on very small screens */
  }
`;

const LeftPanel = styled.div`
  flex: 0.35;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  color: #222;
  overflow-y: auto;
  padding: 20px 25px;
  border-right: 2px solid black;
  box-sizing: border-box;
  scrollbar-width: thin;
  height: 100%;

  &::-webkit-scrollbar {
    width: 1px; /* Webkit scrollbar width */
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  @media (max-width: 992px) {
    border-right: none;
    border-bottom: 2px solid black;
    padding-bottom: 20px;
    flex: none;
    height: auto;
    max-height: 30vh;
  }

  @media (max-width: 576px) {
    padding: 15px;
    gap: 1rem;
    max-height: 30vh;
  }
`;

const Brand = styled.h2`
  color: #15c6a7;
  font-weight: 700;
  font-size: clamp(
    1rem,
    2.5vw,
    20px
  ); /* Adjust fluid value (2.5vw) as needed */
  line-height: 1.2;
  margin: 0;
`;
const BrandMainStyled = styled.h2`
  font-weight: 700;
  font-size: clamp(
    1.2rem,
    3.5vw,
    24px
  ); /* Adjust fluid value (3.5vw) as needed */
  line-height: 1.2;
  margin: 0;
`;

// Component for main brand title with two-color styling
const BrandMain = () => (
  <BrandMainStyled>
    <SearchPart>search</SearchPart>
    <CasaPart>casa</CasaPart>
    <span style={{ color: '#000' }}>®.ch</span>
  </BrandMainStyled>
);

const Headline = styled.h3`
  font-weight: 700;
  font-size: clamp(
    1.1rem,
    3vw,
    1.2rem
  ); /* Adjust fluid value (3vw) as needed */
  line-height: 1.2;
  margin: 0;
`;

const Subheadline = styled.p`
  font-weight: 700;
  font-size: clamp(
    1rem,
    2.8vw,
    18px
  ); /* Adjust fluid value (2.8vw) as needed */
  line-height: 1.2;
  text-align: justify;
  margin: 0;
`;

const Description = styled.span`
  font-size: clamp(
    0.9rem,
    2.5vw,
    18px
  ); /* Adjust fluid value (2.5vw) as needed */
  text-align: justify;
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: 0px;
  color: rgba(0, 0, 0, 1);
  margin: 0;
`;
// Brand name component with two-color styling
const BrandName = styled.span`
  display: inline;
  font-weight: inherit;
`;

const SearchPart = styled.span`
  color: #000000; /* Black for "search" */
`;

const CasaPart = styled.span`
  color: #15c6a7; /* Green for "casa" */
`;

// Helper component for searchcasa branding
const SearchCasaBrand = ({ showDomain = true }) => (
  <BrandName>
    <SearchPart>search</SearchPart>
    <CasaPart>casa</CasaPart>
    {showDomain && '.ch '}
  </BrandName>
);

// Keep for backward compatibility with translated content that might use green highlighting
const SearchCasaHighlight = styled.span`
  color: #15c6a7;
  display: inline;
`;

const Highlight = styled.span`
  font-weight: 700;
  font-size: clamp(
    1rem,
    2.7vw,
    1.1rem
  ); /* Adjust fluid value (2.7vw) as needed */
  margin: 0;
  display: inline;
`;

// --- RIGHT PANEL (IMAGES & CTAS) ---
const RightPanel = styled.div`
  flex: 0.65; /* Adjusted flex ratio: RightPanel is bigger (65%) */
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem; /* Responsive gap */
  justify-content: flex-start;
  overflow: hidden;
  min-height: 100%; /* Ensure it takes full height of ContentOverlay on desktop */
  background: #fff;
  padding: 10px; /* Add some padding */
  box-sizing: border-box;

  @media (max-width: 992px) {
    width: 100%; /* Take full width when stacked */
    min-height: 300px; /* Smaller min-height for stacked layout */
    gap: 1rem;
    height: auto; /* Allow height to adjust when stacked */
  }
`;

const BackgroundSliderWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;

  /* Swiper fade effect styles - ensures clean transitions */
  .swiper-slide {
    opacity: 0 !important;
    transition: opacity 0.8s ease-in-out !important;
  }

  .swiper-slide-active {
    opacity: 1 !important;
  }

  .slick-slider,
  .slick-list,
  .slick-track {
    height: 100%;
  }

  .slick-slide {
    height: 100%;
  }

  .slick-slide > div {
    height: 100%;
  }

  /* Hide navigation arrows and dots for background slider */
  .slick-prev,
  .slick-next {
    display: none !important;
  }

  .slick-dots {
    display: none !important;
  }

  //   /* Optional: Add darkening overlay if you want the 0.8 effect back */
  //   &::after {
  //     content: "";
  //     position: absolute;
  //     top: 0;
  //     left: 0;
  //     width: 100%;
  //     height: 100%;
  //     background: rgba(0, 0, 0, 0.2); /* Adjust this value (0-1) for darkness */
  //     pointer-events: none;
  //     z-index: 1;
  //   }
  //
`;

const HandshakeBackground = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensures image covers area without distortion */
  opacity: 1; /* Must be 1 for clean fade transitions */
  pointer-events: none;
  user-select: none;
`;

const LogoSection = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 576px) {
    margin-top: 0.5rem;
  }
`;
const LogoSectionMain = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 576px) {
    margin-top: 0.5rem;
  }
`;
const Logo = styled.img`
  width: clamp(120px, 20vw, 280px); /* Responsive size */
  height: clamp(50px, 6vw, 75px); /* Responsive size */
`;
const Logo2 = styled.img`
  width: 150px; /* Responsive size */
  height: 150px; /* Responsive size */
  margin-top: clamp(2rem, 5vh, 2rem); /* Responsive margin */
`;

const CTASection = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-around; /* Distributes items evenly */
  width: 100%;
  max-width: 750px; /* Limit max width for buttons */
  margin-top: auto; /* Pushes to bottom of RightPanel */
  padding-bottom: 20px;
  gap: clamp(20px, 10vw, 100px); /* CRITICAL FIX: Responsive gap */

  @media (max-width: 768px) {
    /* Stack buttons vertically on smaller screens */
    align-items: center;
    max-width: 450px; /* Adjust max-width when stacked */
    gap: 15px; /* Smaller gap when stacked */
  }
`;

const CTAButton = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: none;
  background: transparent;
  cursor: pointer;
  font-weight: 700;
  color: rgb(0, 0, 0);
  gap: 8px;
  padding: 0;
  text-decoration: none;
  text-align: center;

  /* Add the transition for a smooth animation */
  transition: transform 0.2s ease-in-out;

  /* The animation effect on hover */
  &:hover {
    transform: scale(1.05); /* Scales the button up by 5% */
  }

  ${(props) =>
    props.$disabled &&
    `
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  `}
`;

const ButtonImage = styled.img`
  width: clamp(140px, 10vw, 60px); /* Responsive size */
  height: clamp(40px, 10vw, 40px); /* Responsive size */
  margin-bottom: 15px; /* Responsive margin */
`;

const Tooltip = styled.div`
  position: absolute;
  bottom: 100%; /* Position above the button */
  left: 50%;
  transform: translateX(-50%) translateY(-10px); /* Adjust Y to give space, keep centered */
  background-color: rgba(0, 0, 0, 0.8);
  color: red;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: clamp(12px, 2.5vw, 14px); /* Responsive font size */
  white-space: nowrap;
  z-index: 10;
  border: 1px solid red;
  pointer-events: none; /* Allows clicks to pass through */

  @media (max-width: 576px) {
    transform: translateX(-50%) translateY(-5px); /* Less vertical space on mobile */
    padding: 6px 10px;
  }
`;

const DemandDashboardContainer = styled.div`
  display: flex;
  flex-direction: row; /* Default desktop layout */
  width: 100%;
  min-height: calc(100vh - 65px); /* Always fill at least viewport minus navbar */
  overflow: hidden;
  flex: 1; /* Take available space from parent */

  /* For screens with FIXED footer (1001px+) - remove fixed height constraints */
  @media (min-width: 1001px) {
    height: auto;
    max-height: none;
  }

  /* Screens with FIXED footer (1001px-1600px) - use min-height to prevent footer overlap */
  @media (min-width: 1001px) and (max-width: 1600px) {
    min-height: calc(100vh - 185px); /* 65px navbar + 120px footer */
  }

  /* For screens with FIXED footer - use min-height to prevent footer overlap */
  @media (min-width: 1601px) {
    min-height: calc(100vh - 185px); /* 65px navbar + 120px footer */
  }

  @media (min-width: 2560px) {
    min-height: calc(100vh - 225px); /* 85px navbar + 140px footer */
  }

  @media (min-width: 3840px) {
    min-height: calc(100vh - 260px); /* 100px navbar + 160px footer */
  }

  @media (max-width: 1000px) {
    flex-direction: column; /* Stack vertically on smaller screens */
    height: auto;
    min-height: calc(100vh - 65px);
    max-height: none;
    overflow-y: auto; /* Allow scrolling on mobile/tablet only */
  }
`;

const MatchingPropertiesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; /* Align to top */
  background-color: #ffffff;
  padding: 10px 8px; /* Compact for 80% zoom */
  box-sizing: border-box;
  flex: 1; /* Take available space */
  width: 100%; /* Full width */
  max-width: 1173px; /* Your desired max-width for the overall content */
  margin: 0 auto; /* Center the container */
  overflow-y: auto; /* Enable scrolling within this container */
  overflow-x: hidden;
  height: 100%; /* Fill parent height */
  max-height: 100%; /* Don't exceed parent */

  /* Maintain consistent behavior across all desktop screen sizes */
  @media (min-width: 1001px) {
    height: 100%;
    max-height: 100%;
    overflow-y: auto;
  }

  @media (max-width: 1000px) {
    /* When main layout stacks on mobile/tablet */
    padding: 15px;
    height: auto;
    min-height: auto;
    overflow-y: visible; /* Parent handles scrolling on mobile */
  }

  @media (max-width: 576px) {
    padding: 10px;
  }
`;

const LowMatchingBanner = styled.div`
  width: 95%;
  margin: 0 auto 10px auto; /* Compact for 80% zoom */
  padding: 10px 15px; /* Compact for 80% zoom */
  background-color: #e8f5e9;
  border: 1px solid #29b185;
  border-radius: 6px;
  color: #1a6b4f;
  font-size: clamp(1rem, 2vw, 1.15rem);
  line-height: 1.4;
  text-align: center;
`;

// Keyframe animations for smooth transitions
const slideOutLeft = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-100%);
  }
`;

const slideInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const PropertyCardWrapper = styled.div`
  background-color: #ffffff; /* Background box color */
  border-radius: 10px;
  padding: clamp(8px, 1.5vw, 15px); /* Compact for 80% zoom */
  width: 95%; /* Make it responsive */
  max-width: 800px; /* Max width for the card */
  max-height: 100%; /* Don't exceed parent container */
  display: flex;
  flex-direction: column;
  gap: clamp(6px, 1vw, 12px); /* Compact for 80% zoom */
  position: relative;
  font-family: "Inter", sans-serif; /* Apply Inter font */
  transform: none; /* Removing the fixed transform for responsiveness */
  overflow-y: auto; /* Allow internal scrolling if content is too tall */
  overflow-x: hidden;
  box-sizing: border-box;

  /* Apply animation based on isSkipping prop */
  animation: ${props => props.$isSkipping ? slideOutLeft : slideInRight} 0.4s ease-in-out;
  animation-fill-mode: forwards;

  /* Large screens (1600px and above) */
  @media (min-width: 1600px) {
    max-width: 1000px;
    padding: clamp(10px, 1.5vw, 18px);
    gap: clamp(8px, 1vw, 14px);
    border-radius: 14px;
  }

  /* Extra large screens (2000px and above) */
  @media (min-width: 2000px) {
    max-width: 1200px;
    padding: clamp(12px, 1.5vw, 20px);
    gap: clamp(10px, 1vw, 16px);
    border-radius: 16px;
  }

  /* Ultra wide screens (2400px and above) */
  @media (min-width: 2400px) {
    max-width: 1400px;
    padding: clamp(14px, 1.5vw, 24px);
    gap: clamp(12px, 1vw, 18px);
    border-radius: 18px;
  }

  @media (min-width: 3840px) {
    max-width: 1800px;
    padding: clamp(16px, 1.5vw, 28px);
    gap: clamp(14px, 1vw, 20px);
  }

  @media (max-width: 1000px) {
    max-height: none; /* Allow natural height on mobile/tablet */
    overflow-y: visible; /* Parent handles scrolling */
  }

  @media (max-width: 576px) {
    padding: 10px; /* Smaller padding on mobile */
    gap: 10px;
    border-radius: 8px; /* Slightly smaller radius on mobile */
  }
`;

const MainImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 45%; /* Compact for 80% zoom */
  overflow: hidden;
  background-color: #e0e0e0;
  border-radius: 8px;

  /* Maintain aspect ratio on mobile */
  @media (max-width: 1000px) {
    padding-top: 56.25%; /* 16:9 aspect ratio on mobile */
  }
`;
const DotIndicatorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
`;

const DotIndicator = styled.span`
  height: 10px;
  width: 10px;
  margin: 0 4px;
  background-color: #fff;
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;
  border: 1px solid #ccc;

  ${(props) =>
    props.$active &&
    `
        background-color: #24B386; /* Or your preferred active color */
    `}
`;

const ImageNavButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 12px;
  z-index: 10;
  border-radius: 50%;
  transition: background-color 0.3s ease;

  &.left {
    left: 15px;
  }

  &.right {
    right: 15px;
  }

  &:hover {
    background-color: rgba(41, 177, 133, 0.3);
  }
`;

const ImageNavIcon = styled.img`
  filter: invert(36%) sepia(35%) saturate(1637%) hue-rotate(113deg)
    brightness(88%) contrast(92%);
  width: 40px;
  height: 40px;
`;

const MainImage = styled.img`
  position: absolute; /* Absolute positioning is key here */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensures the image covers the container without distortion */
`;

const ThumbnailsCarouselWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  overflow-x: auto;
  padding: 0 10px;

  /* Hide scrollbar for cleaner UI */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

// Holds all the thumbnails in a single row
const ThumbnailsContainer = styled.div`
  position: relative; /* now nav buttons will be positioned relative to this */
  display: flex;
  justify-content: center;
  gap: clamp(5px, 1.5vw, 10px);
  flex-wrap: nowrap;
  padding: 5px 0;
  width: fit-content;
  margin: 0 auto;
`;

// 16:9 ratio thumbnail wrapper
const ThumbnailImageWrapper = styled.div`
  position: relative;
  aspect-ratio: 16 / 9; /* ensures perfect 16:9 shape */
  width: clamp(80px, 14vw, 120px); /* wider so 16:9 looks natural */
  border-radius: 6px;
  cursor: pointer;
  border: 2px solid ${(props) => (props.$active ? "#29B185" : "#CCCCCC")};
  transition: border-color 0.3s ease;
  flex-shrink: 0;

  &:hover {
    border-color: #29b185;
  }
`;

const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover; /* keeps image proportion without stretching */
  border-radius: 4px;
  display: block;
`;

const PropertyDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(100px, 1fr)
  ); /* Responsive columns */
  gap: clamp(5px, 2vw, 10px); /* Responsive gap */
  text-align: center;
  align-items: end; /* Align items to the bottom */
  width: 95%; /* Responsive width */
  margin: 0 auto;

  /* Large screens */
  @media (min-width: 1600px) {
    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
    gap: clamp(8px, 2vw, 14px);
  }

  @media (min-width: 2000px) {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: clamp(10px, 2vw, 16px);
  }

  @media (min-width: 2400px) {
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
    gap: clamp(12px, 2vw, 18px);
  }

  @media (min-width: 3840px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(
      auto-fit,
      minmax(80px, 1fr)
    ); /* Adjust min width for smaller screens */
  }
  @media (max-width: 576px) {
    grid-template-columns: repeat(
      auto-fit,
      minmax(60px, 1fr)
    ); /* Further adjust for mobile */
  }
`;

const PropertyDetailsGrid2 = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(100px, 1fr)
  ); /* Responsive columns */
  gap: clamp(5px, 2vw, 10px); /* Responsive gap */
  text-align: center;
  background-color: #c9ebe0;
  border-radius: 50px; /* Pill-shaped */
  height: auto; /* Allow height to adjust based on content */
  width: 95%; /* Responsive width */
  margin: 0 auto;
  padding: clamp(8px, 2vw, 12px) 0; /* Responsive padding */
  align-items: center; /* Center items vertically within the pill */

  /* Large screens */
  @media (min-width: 1600px) {
    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
    gap: clamp(8px, 2vw, 14px);
    padding: clamp(10px, 2vw, 16px) 0;
  }

  @media (min-width: 2000px) {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: clamp(10px, 2vw, 16px);
    padding: clamp(12px, 2vw, 18px) 0;
  }

  @media (min-width: 2400px) {
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
    gap: clamp(12px, 2vw, 18px);
    padding: clamp(14px, 2vw, 20px) 0;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  }
  @media (max-width: 576px) {
    grid-template-columns: repeat(auto-fit, minmax(60px, 1fr));
    border-radius: 30px; /* Smaller radius on mobile */
  }
`;

const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.9rem; /* Base font size */
  color: #555;
`;

const DetailLabel = styled.span`
  font-weight: 600;
  color: #29b185;
  margin-bottom: clamp(3px, 1vw, 5px); /* Responsive margin */
  font-size: clamp(0.9rem, 2.5vw, 1.2rem); /* Responsive font size */

  /* Large screens */
  @media (min-width: 1600px) {
    font-size: clamp(1.1rem, 2.5vw, 1.4rem);
  }

  @media (min-width: 2000px) {
    font-size: clamp(1.2rem, 2.5vw, 1.6rem);
  }

  @media (min-width: 2400px) {
    font-size: clamp(1.3rem, 2.5vw, 1.8rem);
  }

  @media (min-width: 3840px) {
    font-size: clamp(1.4rem, 2.5vw, 2rem);
  }
`;

const DetailValue = styled.span`
  font-size: clamp(0.8rem, 2.2vw, 1.1rem); /* Responsive font size */
  color: #000;
  white-space: nowrap; /* Prevent values from wrapping */
  overflow: hidden;
  text-overflow: ellipsis; /* Add ellipsis if truncated */

  /* Large screens */
  @media (min-width: 1600px) {
    font-size: clamp(1rem, 2.2vw, 1.3rem);
  }

  @media (min-width: 2000px) {
    font-size: clamp(1.1rem, 2.2vw, 1.5rem);
  }

  @media (min-width: 2400px) {
    font-size: clamp(1.2rem, 2.2vw, 1.7rem);
  }

  @media (min-width: 3840px) {
    font-size: clamp(1.2rem, 2.2vw, 1.8rem);
  }
`;

const LowMatchingInfoSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: clamp(10px, 3vw, 15px) 0;
  border-top: 1px solid #eee;
  width: 95%;
  margin: 0 auto;
`;

const LowMatchingTitle = styled.h3`
  font-size: clamp(1rem, 2.5vw, 1.2rem);
  font-weight: 600;
  color: #29b185;
  margin-bottom: 10px;
`;

const LowMatchingDescription = styled.p`
  font-size: clamp(0.9rem, 2vw, 1rem);
  color: #666;
  line-height: 1.5;
  margin: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  max-width: 100%;
`;

const LowMatchingHeading = styled.h4`
  font-size: clamp(0.95rem, 2.2vw, 1.1rem);
  font-weight: 600;
  color: #29b185;
  margin-bottom: 8px;
  margin-top: 0;
`;

const LowMatchingValue = styled.p`
  font-size: clamp(0.9rem, 2vw, 1rem);
  color: #333;
  // line-height: 1.5;
  // margin: 0 0 15px 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  max-width: 100%;
`;

const ShowMoreButton = styled.button`
  background: none;
  border: none;
  color: #29b185;
  font-size: clamp(0.85rem, 1.8vw, 0.95rem);
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  margin-left: 5px;
  text-decoration: underline;
  display: inline;

  &:hover {
    color: #1a6b4f;
  }
`;

const DescriptionSection = styled.div`
  margin-top: 8px;
  padding-top: 0;
  width: 95%;
  // margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  overflow: hidden;
`;

const MatchScoreSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start; /* Align items to the top */
  // padding: clamp(10px, 3vw, 15px) 0; /* Responsive padding */
  padding-top: 10px;
  border-top: 1px solid #eee;
  font-size: 1rem;
  width: 95%; /* Responsive width */
  margin: 0 auto;

  @media (max-width: 576px) {
    /* Stack columns on mobile */
    align-items: center;
    gap: 150px;
  }
`;

const ScoreColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(3px, 1vw, 5px); /* Responsive gap */
  width: 48%; /* Distribute space */
  box-sizing: border-box; /* Include padding/border in width */

  @media (max-width: 576px) {
    width: 100%; /* Full width when stacked */
    align-items: center; /* Center text when stacked */
  }
`;

const MainScoreLabel = styled.span`
  font-weight: 700;
  color: #29b185;
  font-size: clamp(1.1rem, 3vw, 1.3rem); /* Restored font size */
`;

const CriteriaLabel = styled.span`
  font-weight: 600;
  color: #cccccc;
  font-size: clamp(0.9rem, 2.5vw, 1.1rem); /* Restored font size */
`;

const MatchPercentageValue = styled.span`
  font-weight: 700;
  color: #29b185;
  font-size: clamp(1.3rem, 3.5vw, 1.5rem); /* Restored font size */
`;

const CriteriaScoreValue = styled.span`
  font-weight: 700;
  color: #cccccc;
  font-size: clamp(0.9rem, 2.5vw, 1.1rem); /* Restored font size */
`;
const FooterActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center; /* Vertically center the items */
  width: 95%; /* Match the width of other elements */
  margin: 20px auto 0 auto; /* Restored margin */

  @media (max-width: 576px) {
    flex-direction: column; /* Stack vertically on small screens */
    align-items: center;
    gap: 10px;
  }
`;
const UserTypeBadge = styled.div`
  background-color: #c9ebe0;
  color: #29b185;
  padding: clamp(8px, 2vw, 12px) clamp(25px, 8vw, 60px); /* Restored padding */
  border-radius: 20px;
  font-size: clamp(1rem, 3vw, 1.1rem); /* Restored font size */
  align-self: center;
  margin-top: 15px; /* Restored margin */
  text-transform: uppercase;
  font-family: "Yanone Kaffeesatz", sans-serif; /* Keep font family */
  width: fit-content; /* Fit content, but can be responsive with padding */
  margin: 15px auto 0 auto; /* Center horizontally, keep top margin */

  /* Large screens */
  @media (min-width: 1600px) {
    padding: clamp(8px, 2vw, 12px) clamp(30px, 8vw, 60px);
    font-size: clamp(1.1rem, 3vw, 1.2rem);
    border-radius: 25px;
  }

  @media (min-width: 2000px) {
    padding: clamp(10px, 2vw, 14px) clamp(35px, 8vw, 70px);
    font-size: clamp(1.2rem, 3vw, 1.4rem);
    border-radius: 30px;
  }

  @media (min-width: 2400px) {
    padding: clamp(12px, 2vw, 16px) clamp(40px, 8vw, 80px);
    font-size: clamp(1.3rem, 3vw, 1.6rem);
    border-radius: 35px;
  }

  @media (max-width: 576px) {
    padding: clamp(5px, 3vw, 8px) clamp(15px, 6vw, 40px);
    font-size: clamp(1rem, 4vw, 1.5rem);
  }
`;

const ActionButtons = styled.div`
  display: flex;
  justify-content: space-around; /* Distribute space */
  gap: 70%; /* Responsive gap */
  margin-top: 20px; /* Restored margin */
  width: 95%; /* Responsive width */
  margin: 20px auto 0 auto; /* Center horizontally, restored top margin */

  @media (max-width: 576px) {
    /* Stack buttons on mobile */
    align-items: center;
    gap: 150px;
  }
`;

const ActionButton = styled.button`
  display: flex;
  flex-direction: column; /* Stack icon above text */
  align-items: center;
  border: none;
  background-color: transparent;
  font-size: 1rem; /* Restored font size */
  font-weight: bold;
  cursor: pointer;
  gap: 6px; /* Restored space between icon and text */
  padding: 0;
  border-radius: 0;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }

  ${(props) =>
    props.$primary &&
    `
    color: #333;
  `}

  ${(props) =>
    props.$secondary &&
    `
    color: #333;
  `}
`;

const ActionButtonIcon = styled.img`
  width: clamp(35px, 8vw, 45px); /* Restored icon size */
  height: clamp(35px, 8vw, 45px);
  ${(props) =>
    props.$color === "white" &&
    `
    filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);
  `}
  ${(props) =>
    props.$color === "black" &&
    `
    filter: invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%);
  `}
  ${(props) =>
    props.$color === "red" &&
    `
    filter: invert(23%) sepia(94%) saturate(4867%) hue-rotate(355deg) brightness(88%) contrast(113%);
  `}
  ${(props) =>
    props.$color === "green" &&
    `
    filter: invert(58%) sepia(27%) saturate(1044%) hue-rotate(113deg) brightness(91%) contrast(84%);
  `}

  /* Large screens */
  @media (min-width: 1600px) {
    width: clamp(40px, 8vw, 50px);
    height: clamp(40px, 8vw, 50px);
  }

  @media (min-width: 2000px) {
    width: clamp(45px, 8vw, 60px);
    height: clamp(45px, 8vw, 60px);
  }

  @media (min-width: 2400px) {
    width: clamp(50px, 8vw, 70px);
    height: clamp(50px, 8vw, 70px);
  }
`;

const ActionButtonText = styled.span`
  font-size: clamp(0.95rem, 2.5vw, 1.05rem); /* Restored text size */
  font-weight: 500;

  /* Large screens */
  @media (min-width: 1600px) {
    font-size: clamp(1.05rem, 2.5vw, 1.25rem);
  }

  @media (min-width: 2000px) {
    font-size: clamp(1.15rem, 2.5vw, 1.45rem);
  }

  @media (min-width: 2400px) {
    font-size: clamp(1.25rem, 2.5vw, 1.65rem);
  }
`;

const FreeRegImage = styled.img`
  width: auto; /* Adjust width as needed */
  height: auto; /* Adjust height as needed */
  max-width: 200px; /* Example max width */
  position: absolute;
  top: 12%; /* Adjust top position as needed */
  left: -0.5%; /* Adjust left position to move it to the left, may need to be negative */
  transform: rotate(-45deg); /* Adjust the rotation angle */
  z-index: 1; /* Ensure it's above the background */

    /* Media query for tablets and smaller screens */
  @media (max-width: 992px) {
    max-width: 25.5vw; /* Make it proportionally larger on smaller screens */
    top: 5%; /* Adjust top position */
    left: -0.5vw; /* Adjust left position */
    top: 12%;
    transform: rotate(-45deg); /* Adjust rotation for a better fit */
  }

  /* Media query for mobile devices */
  @media (max-width: 576px) {
    
    max-width: 30vw;
    top: 12%;
    left: -0.5vw;
    transform: rotate(-45deg);
    */
  }

 `;

const NoPropertiesMessage = styled.div`
  text-align: center;
  font-size: clamp(1.2rem, 3vw, 1.5rem); /* Responsive font size */
  color: #555;
  padding: clamp(30px, 8vw, 50px); /* Responsive padding */
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  margin: 50px auto; /* Responsive margin, centered */

  @media (max-width: 576px) {
    padding: 20px;
    margin: 30px auto;
  }
`;

const LoadingMessage = styled.div`
  text-align: center;
  font-size: clamp(1.2rem, 3vw, 1.5rem); /* Responsive font size */
  color: #555;
  padding: clamp(30px, 8vw, 50px); /* Responsive padding */
`;
const TrendingLeftPanel = styled.div`
  border-radius: 4px;
  width: 270px; /* Match MySearch */
  min-width: 250px;
  max-width: 270px;
  flex-shrink: 0;
  padding: 12px; /* Match MySearch */
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-right: 1px solid #ddd;
  align-self: stretch; /* Stretch to fill container height */
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  /* For screens with fixed footer - fill container height */
  @media (min-width: 1001px) {
    height: calc(110vh);
    // padding: 0;
  }

  @media (min-width: 2560px) {
    width: 350px; /* Match MySearch */
    min-width: 320px;
    max-width: 350px;
    height: calc(100vh - 225px);
  }

  @media (min-width: 3840px) {
    width: 450px; /* Match MySearch */
    min-width: 400px;
    max-width: 450px;
    height: calc(100vh - 260px);
  }

  @media (max-width: 992px) {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #ddd;
    margin-right: 0;
    margin-bottom: 10px;
    height: auto;
    max-height: none;
    overflow: hidden;
    padding-bottom: 30px;
  }

  @media (max-width: 767px) {
    padding: 10px;
    padding-bottom: 15px;
  }

  @media (max-width: 576px) {
    padding: 10px;
    padding-bottom: 25px;
  }
`;

const NewSearchesHeader = styled.div`
  padding: 15px;
  text-align: center;
  align-self: center;

  /* For large screens - keep consistent padding to match MySearch */
  @media (min-width: 1920px) and (min-height: 1000px) {
    padding: 10px; /* Match MySearch */
  }

  @media (max-width: 767px) {
    padding: 10px;
  }
`;

const NewSearchesTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 800;
  color: #29b185;
  margin: 0;

  @media (max-width: 767px) {
    font-size: 1.4rem;
    margin-bottom: 10px;
  }

  /* Removed aggressive scaling to match MySearch */
`;

const PropertyList = styled.div`
  margin-top: 0;
  display: block;
  overflow: hidden;
  width: 100%;
  flex: 1; /* Take remaining space in TrendingLeftPanel */
  height: 100%; /* Fill parent to touch footer */
  position: relative;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  /* Ensure full height on desktop screens */
  @media (min-width: 1001px) {
    height: 100%; /* Fill leftPanel to touch footer */
  }

  /* Consistent behavior for all desktop screens - fill available space */
  @media (min-width: 1001px) {
    height: 100%;
    max-height: 100%;
  }

  @media (max-width: 1000px) {
    height: auto;
    max-height: none;
    min-height: 400px;
  }

  @media (max-width: 767px) {
    height: auto;
    min-height: auto;
    max-height: none;
    margin-top: 0;
    padding: 10px 0;
  }

  @media (max-width: 576px) {
    height: auto;
    min-height: auto;
    max-height: none;
    padding: 5px 0;
  }
`;

const TrendingCardsWrapper = styled.div`
  width: 100%; /* This needs to be 100% to contain the slider */
  padding: 0 10px; /* Add some horizontal padding to the slider itself */
  box-sizing: border-box; /* Include padding in width */

  /* Styles for Slick Slider elements */
  .slick-list {
    margin: 0 -5px; /* Counteract padding on slick-slide to maintain overall alignment */
  }
  .slick-slide > div {
    /* Target the div directly inside slick-slide */
    padding: 0 5px; /* Add internal padding to each card space */
    box-sizing: border-box;
  }
  .slick-prev:before,
  .slick-next:before {
    font-size: 30px; /* Size of the navigation arrows */
    color: rgba(41, 177, 133, 1); /* Color of the navigation arrows */
  }
  .slick-prev {
    left: -25px; /* Position the previous arrow */
    z-index: 1; /* Ensure arrows are above slides */
  }
  .slick-next {
    right: -25px; /* Position the next arrow */
    z-index: 1;
  }
  .slick-dots li button:before {
    font-size: 10px; /* Size of dots */
    color: #ccc; /* Color of inactive dots */
  }
  .slick-dots li.slick-active button:before {
    color: rgba(41, 177, 133, 1); /* Color of active dot */
  }

  /* For large screens like iMac (2240x1260) - reduce gaps */
  @media (min-width: 1920px) and (min-height: 1000px) {
    .slick-slide {
      margin-bottom: 0;
      padding: 0;
    }
    .slick-list {
      margin: 0;
    }
    .slick-slide > div {
      padding: 0;
    }
  }

  @media (min-width: 993px) {
    /* On desktop, revert to standard stacking */
    padding: 0; /* Remove horizontal padding on desktop */
    /* Remove any flex/overflow properties that would interfere with vertical stacking */
  }

  @media (max-width: 576px) {
    padding: 0 5px; /* Less padding on very small screens */
    .slick-prev {
      left: -15px;
    }
    .slick-next {
      right: -8px;
    }
  }
`;
const PropertyCard = styled.div`
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin: 5px;
  overflow: hidden;
  transition:
    transform 0.2s,
    box-shadow 0.2s;
  cursor: pointer;
  width: 240px; /* Increased to match MySearch better */
  height: 220px; /* Fixed height to prevent compression */
  flex-shrink: 0; /* Prevent shrinking in flex containers */
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }

  /* For large screens like iMac (2240x1260) - reduce gap between cards */
  @media (min-width: 1920px) and (min-height: 1000px) {
    margin: 1px 5px; /* Minimized vertical margin to 1px for very tight spacing */
  }

  @media (max-width: 992px) {
    margin-bottom: 20px;
    width: calc(50% - 10px);
    margin-right: 10px;
  }

  @media (max-width: 767px) {
    width: calc(100% - 20px);
    max-width: 100%;
    margin: 10px auto;
  }

  @media (max-width: 576px) {
    margin-bottom: 15px;
    width: 100%;
    margin-right: 0;
  }

  @media (min-width: 2560px) {
    width: 300px; /* Match MySearch sizing */
  }
  @media (min-width: 3840px) {
    width: 380px; /* Match MySearch sizing */
  }
`;
const PropertyCardSponcer = styled.div`
  margin-bottom: 20px;
  background-color: White;
  border-radius: 8px;
  box-shadow: 0px 1px 3px 1px #00000026;
  height: 133px;
  width: 237px;
  flex-direction: column;
  align-items: center;
  width: 237px;

  flex-shrink: 0;
  flex-basis: auto; /* Let content determine initial size, or set a specific desktop basis */
  flex-grow: 0; /* Don't grow on desktop unless needed */

  /* For large screens like iMac (2240x1260) - reduce gap between cards */
  @media (min-width: 1920px) and (min-height: 1000px) {
    margin: 1px 5px; /* Minimized vertical margin to 1px for very tight spacing */
    margin-bottom: 1px;
  }

  /* Responsive Styles for Tablets and Smaller Screens */
  @media (max-width: 768px) {
    width: 100%; /* Take full width of parent on smaller screens */
    max-width: 200px; /* <--- Smaller max-width for tablets/mobiles */
    min-width: 150px; /* <--- Prevents it from getting too small */
    min-height: 180px; /* <--- Smaller min-height for tablets/mobiles */
    height: auto; /* Allow height to adjust based on content */

    /* Adjust flex-basis for responsive grid if cards are in a flex container */
    flex-basis: calc(50% - 15px); /* Example: 2 cards per row on tablets */
    flex-grow: 1; /* Allow growing on smaller screens */
    flex-shrink: 1; /* Allow shrinking on smaller screens */
  }

  /* Responsive Styles for Mobile Phones */
  @media (max-width: 480px) {
    max-width: 80%; /* Take up most of the screen width */
    flex-basis: 100%; /* One card per row on very small screens */
    margin-left: auto; /* Center the single card */
    margin-right: auto; /* Center the single card */
  }
`;

const PropertyImageContainer = styled.div`
  position: relative;
  height: 100px;
  background-color: #ddd;
  margin-bottom: 8px;
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-width: 767px) {
    height: 180px;
    margin-bottom: 8px;
  }

  @media (max-width: 576px) {
    height: 160px;
    margin-bottom: 5px;
  }
`;

const PropertyImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
`;
const PropertyImageSponcer = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 105%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
`;

const PropertyText = styled.p`
  font-size: clamp(14px, 2.5vw, 16px); /* Responsive font size */
  color: #555;
  text-align: justify;
  width: calc(
    100% - 20px
  ); /* Adjust width to account for padding within card */
  height: 46px; /* Fixed height for two lines of text (approx) */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-height: 1.3;
  margin: 0 10px 10px 10px; /* Margin to create internal padding */
  box-sizing: border-box;
`;

const PropertyHighlightText = styled.span`
  color: rgba(41, 177, 133, 1);
  font-weight: 700;
  font-size: 20px; /* Corrected to include the 'px' unit to match the CSS class */
`;

// Helper function to format CHF prices with comma thousand separators
const formatWithApostrophe = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const numValue =
    typeof value === "string"
      ? Number(value.replace(/[' ,]/g, ""))
      : Number(value);
  if (Number.isNaN(numValue)) return value;
  
  // Format with Swiss CHF format (apostrophe as thousand separator)
  const formatted = numValue.toFixed(2);
  const parts = formatted.split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  return `${integerPart}.${parts[1]}`;
};

const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
};

// New styled components for property details matching SearchProperty.js
const PropertyDetails = styled.div`
  padding: 12px 15px; /* Restored padding */
  display: flex;
  flex-direction: column;
  gap: 10px; /* Restored gap */
  flex: 1;
  min-height: 0;

  @media (max-width: 767px) {
    padding: 10px 12px;
    gap: 10px;
  }
`;

const PropertyLocation = styled.div`
  font-weight: 900;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

const LocationTextHead = styled.h2`
  font-size: 1.1rem; /* Restored font size */
  font-weight: 600;
  color: #333;
  margin: 0;
  line-height: 1.2;

  @media (max-width: 767px) {
    font-size: 1.1rem;
  }
`;

const LocationText = styled.p`
  font-size: 0.95rem; /* Restored font size */
  color: #555;
  margin: 0;
  line-height: 1.4;

  @media (max-width: 767px) {
    font-size: 0.9rem;
    line-height: 1.4;
  }
`;

const PropertyStats = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px; /* Restored gap */
  margin-top: 10px; /* Restored margin */

  @media (max-width: 767px) {
    gap: 8px;
    margin-top: 15px;
  }
`;

const StatLine = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const StatIcon = styled.img`
  width: 18px; /* Restored icon size */
  height: 18px;
  object-fit: contain;

  @media (max-width: 767px) {
    width: 14px;
    height: 14px;
  }
`;

const StatText = styled.span`
  font-size: 0.9rem; /* Restored font size */
  color: #555;

  @media (max-width: 767px) {
    font-size: 0.85rem;
  }
`;

// Card header styled components matching MyProperties.js
const CardHeader = styled.div`
  background-color: #29b185;
  color: white;
  padding: 12px 16px; /* Restored padding */
  display: flex;
  align-items: center;
  gap: 10px; /* Restored gap */
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
`;

const RedCardHeader = styled.div`
  background-color: #c9ebe0;
  color: black;
  padding: 12px 16px; /* Restored padding */
  display: flex;
  align-items: center;
  gap: 10px; /* Restored gap */
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
`;

const SearchIconWrapper = styled.div`
  background-color: black;
  border-radius: 50%;
  margin-left: -5%;
  width: 30px; /* Restored size */
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const SearchIconImg = styled.img`
  width: 18px; /* Restored size */
  height: 18px;
  color: white;
  stroke: white;
`;

const CardTitle = styled.p`
  font-weight: 900;
  font-size: 20px; /* Restored font size */
  margin: 0;
  margin-top: 12px; /* Restored margin */
  margin-bottom: 6px; /* Restored margin */
  line-height: 1.2;
`;

const LocationTextWithIcon = styled.p`
  font-size: 0.95rem; /* Restored font size */
  color: #555;
  margin: 0;
  line-height: 1.4;
  display: flex;
  align-items: center;
  gap: 6px; /* Restored gap */

  @media (max-width: 767px) {
    font-size: 0.9rem;
    line-height: 1.4;
  }
`;

// --- MODAL STYLES (for confirmation modal) ---
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: #fff;
  padding: clamp(20px, 5vw, 30px); /* Responsive padding */
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  text-align: center;
  max-width: 400px;
  width: 90%; /* Responsive width */
  font-family: "Inter", sans-serif;
  position: relative;

  @media (max-width: 576px) {
    padding: 15px;
    border-radius: 8px;
  }
`;

const ModalMessage = styled.p`
  font-size: clamp(1rem, 2.8vw, 1.1rem); /* Responsive font size */
  color: #333;
  text-align: justify;
  margin-bottom: clamp(15px, 4vw, 25px); /* Responsive margin */
  line-height: 1.5;
`;

const ModalButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  gap: clamp(10px, 3vw, 15px); /* Responsive gap */

  @media (max-width: 576px) {
    flex-direction: column; /* Stack buttons on mobile */
  }
`;

const ModalButton = styled.button`
  padding: clamp(10px, 3vw, 12px) clamp(15px, 5vw, 25px); /* Responsive padding */
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: clamp(0.9rem, 2.5vw, 1rem); /* Responsive font size */
  font-weight: 600;
  transition:
    background-color 0.3s ease,
    transform 0.2s ease;
  flex: 1; /* Make buttons take equal space */

  &:hover {
    transform: translateY(-2px);
  }

  &.confirm {
    background-color: #29b185;
    color: white;
  }
  &.cancel {
    background-color: #e0e0e0;
    color: #333;
  }
`;

const Home = ({ setHideFooter, setHideNavbar }) => {
  const navigate = useNavigate();
  const { isAuthenticated, currentUser, loadingAuth } = useAuth();
  const { currentFlow } = useFlow();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [properties, setProperties] = useState([]);
  const [currentPropertyIndex, setCurrentPropertyIndex] = useState(0);
  const [loadingProperties, setLoadingProperties] = useState(true);
  const [error, setError] = useState(null);
  const [mainDisplayImage, setMainDisplayImage] = useState("");
  const [showOfferTooltip, setShowOfferTooltip] = useState(false);
  const [showSearchTooltip, setShowSearchTooltip] = useState(false);
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const languageDropdownRef = useRef(null);
  const [demands, setDemands] = useState([]);
  const [sliderKey, setSliderKey] = useState(Date.now());
  const [isSkipping, setIsSkipping] = useState(false);
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);

  // Helper function to get the appropriate room/unit label based on property type
  const getRoomLabel = (propertyType) => {
    if (!propertyType) return t("Bedrooms");
    const type = propertyType.toLowerCase();
    if (type === "multifamily") {
      return t("Units");
    }
    if (type === "plot") {
      return t("Index");
    }
    // For apartment, house/villa, and others
    return t("Bedrooms");
  };

  // Helper function to get the appropriate room/unit value based on property type
  const getRoomValue = (propertyType, bedrooms, units, index) => {
    console.log('🔍 getRoomValue called:', { propertyType, bedrooms, units, index });
    if (!propertyType) return bedrooms || units || index || "-";
    const type = propertyType.toLowerCase();
    if (type === "plot") {
      console.log('📊 Returning index for plot:', index);
      return index || "-";
    }
    if (type === "multifamily") {
      console.log('📊 Returning units for multifamily:', units);
      return units || "-";
    }
    // For apartment, house/villa, and others
    console.log('🏠 Returning bedrooms for other types:', bedrooms);
    return bedrooms || "-";
  };

  const [isLoading, setIsLoading] = useState(true);
  const [minMatchPercentage, setMinMatchPercentage] = useState(40); // Default to 40, will be fetched from system settings

  // Reset description expanded state when property changes
  useEffect(() => {
    setIsDescriptionExpanded(false);
  }, [currentPropertyIndex]);

  // Fetch minimum matching percentage from system settings
  useEffect(() => {
    const fetchMinMatchPercentage = async () => {
      try {
        const response = await authFetch(`${BASE_URL}/settings/matching-percentage`);
        const result = await response.json();
        if (result.data && result.data.minPercentage) {
          setMinMatchPercentage(result.data.minPercentage);
          console.log('✅ Fetched min matching percentage:', result.data.minPercentage);
        }
      } catch (error) {
        console.error('Error fetching min matching percentage:', error);
        // Keep default value (40) on error
      }
    };

    fetchMinMatchPercentage();
  }, []);

  const images = [
    background1,
    background2,
    background3,
    background4,
    background5,
    background6,
    background7,
    background8,
    background9,
    background10,
    background11,
    background12,
    background13,
    background14,
    background15,
    background16,
    background17,
    background18,
    background19,
    background20,
    background21,
    background22,
    background23,
    background24,
  ];
  useEffect(() => {
    const fetchDemands = async () => {
      try {
        const response = await authFetch(
          `${BASE_URL}/property/latest/demands?limit=30`,
        );
        if (!response.ok) {
          throw new Error("Failed to fetch demands");
        }

        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const data = await response.json();
          setDemands(data);
        } else {
          const text = await response.text();
          throw new Error(
            `Server returned a non-JSON response. Check your API route. Response was: "${text.substring(
              0,
              50,
            )}..."`,
          );
        }
      } catch (err) {
        setError(err.message);
        console.error("Error fetching demands:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDemands();

    // Poll every 60 seconds to avoid interrupting animation
    // const intervalId = setInterval(fetchDemands, 60000);

    return () => {
      // Polling disabled to prevent property changes during animation
      // clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    const isMarketingPageScenario = !isAuthenticated;

    if (isMarketingPageScenario) {
      setHideFooter(true);
      setHideNavbar(true);
    } else {
      setHideFooter(false);
      setHideNavbar(false);
    }

    return () => {
      // Polling disabled to prevent property changes during animation
      setHideFooter(false);
      setHideNavbar(false);
    };
  }, [isAuthenticated, setHideFooter, setHideNavbar]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        languageDropdownRef.current &&
        !languageDropdownRef.current.contains(event.target)
      ) {
        setShowLanguageDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Extract fetchProperties as a reusable function
  const fetchProperties = useCallback(async () => {
    console.log("🎬 fetchProperties called - VERSION 3.0 (Combined)");
    console.log("Timestamp:", new Date().toISOString());
    console.log("Current user:", currentUser);
    console.log("User type:", currentUser?.userType);
    
    if (
      !loadingAuth &&
      isAuthenticated &&
      currentUser &&
      currentUser.userType === "demand"
    ) {
      console.log("✅ User is demand type, fetching properties...");
      setLoadingProperties(true);
      setError(null);
      try {
        // Fetch both APIs in parallel
        console.log("📞 Calling both APIs in parallel...");
        const [matchingResponse, allOffersResponse] = await Promise.all([
          authFetch(`${BASE_URL}/property/matching/properties`),
          authFetch(`${BASE_URL}/property/all-offers-simple`)
        ]);

        console.log("📥 Matching API status:", matchingResponse.status);
        console.log("📥 All Offers API status:", allOffersResponse.status);

        const matchingResult = matchingResponse.ok ? await matchingResponse.json() : { data: [] };
        const allOffersData = allOffersResponse.ok ? await allOffersResponse.json() : [];

        // API returns { message, data: [...] } — extract the array
        const allMatchRecords = Array.isArray(matchingResult.data) ? matchingResult.data : [];

        // Only show pending algorithmic matches on home page (user hasn't decided yet)
        // Deduplicate by offerPropertyId — a user with multiple demand properties may have
        // multiple match records for the same offer. Backend sorts by matchPercentage DESC,
        // so the first occurrence is the best match.
        const seenOfferIds = new Set();
        const pendingMatches = allMatchRecords
          .filter(m => m.status === 'pending')
          .filter(m => {
            if (seenOfferIds.has(m.offerPropertyId)) return false;
            seenOfferIds.add(m.offerPropertyId);
            return true;
          });

        console.log("📦 All match records:", allMatchRecords.length);
        console.log("📦 Pending matches to show:", pendingMatches.length);
        console.log("📦 All offer properties:", Array.isArray(allOffersData) ? allOffersData.length : 0);

        // Exclude ALL already-interacted properties (pending, accepted, skipped)
        // so they don't reappear in the all-offers fallback section
        const interactedPropertyIds = new Set(allMatchRecords.map(m => m.offerPropertyId));

        // Transform all-offers-simple data to match the structure
        const transformedAllOffers = (Array.isArray(allOffersData) ? allOffersData : []).map(property => ({
          id: null, // No matching record yet
          status: 'pending',
          matchPercentage: null,
          offerPropertyId: property.id,
          Property: {
            id: property.id,
            displayId: property.displayId,
            propertyTitle: property.propertyTitle,
            description: property.description,
            price: property.price,
            currency: property.currency,
            squareMeters: property.sqm,
            bedrooms: property.bedrooms,
            units: property.units,
            index: property.index,
            propertyType: property.propertyType,
            PropertyShowcase: {
              mainImage: property.mainImage,
              images: property.images,
            },
            PropertyAddresses: [{
              city: property.city,
              zipCode: property.zipCode,
              countryName: property.country,
            }],
            User: property.user || {
              id: null,
              name: null,
              surname: null,
              isPrivate: false,
              companyName: null,
            },
          }
        }));

        // Remove offers the user has already interacted with
        const uniqueAllOffers = transformedAllOffers.filter(
          offer => !interactedPropertyIds.has(offer.Property.id)
        );

        // Algorithmic pending matches first (sorted by matchPercentage DESC by backend),
        // then remaining unmatched offer properties
        const combinedProperties = [
          ...pendingMatches,
          ...uniqueAllOffers
        ];

        console.log("✅ Combined properties:", combinedProperties.length);
        console.log("  - Pending algorithmic matches:", pendingMatches.length);
        console.log("  - Additional unmatched offers:", uniqueAllOffers.length);

        setProperties(combinedProperties);
        setCurrentPropertyIndex(0);
        if (combinedProperties.length > 0) {
          setMainDisplayImage(
            combinedProperties[0].Property.PropertyShowcase.mainImage ||
              "https://placehold.co/800x400/EEEEEE/333333?text=No+Image",
          );
        } else {
          setMainDisplayImage("");
        }
      } catch (err) {
        console.error("❌ Error fetching properties:", err);
        console.error("Error details:", {
          message: err.message,
          stack: err.stack,
        });
        setError(t("Error_Fetching_Properties"));
        setProperties([]);
      } finally {
        setLoadingProperties(false);
      }
    } else {
      console.log("❌ Conditions not met for fetching:");
      console.log("- loadingAuth:", loadingAuth);
      console.log("- isAuthenticated:", isAuthenticated);
      console.log("- currentUser:", currentUser);
      console.log("- userType:", currentUser?.userType);
      
      if (!isAuthenticated || currentUser?.userType !== "demand") {
        setProperties([]);
        setLoadingProperties(false);
        setError(null);
      }
    }
  }, [isAuthenticated, currentUser, loadingAuth]); // Removed 't' to prevent re-fetch on language change

  useEffect(() => {
    if (currentUser?.userType === "demand") {
      fetchProperties();
    }
  }, [currentUser?.userType, fetchProperties]);

  useEffect(() => {
    if (properties.length > 0 && currentPropertyIndex < properties.length) {
      const currentProperty = properties[currentPropertyIndex];
      setMainDisplayImage(
        currentProperty.Property.PropertyShowcase.mainImage ||
          "https://placehold.co/800x400/EEEEEE/333333?text=" + t("No_Image"),
      );
    } else if (properties.length === 0) {
      setMainDisplayImage("");
    }
  }, [currentPropertyIndex, properties, t]);

  const handleDiscoverMore = () => {
    if (properties.length === 0) return;
    setShowConfirmationModal(true);
  };

  const confirmDiscoverMore = async () => {
    setShowConfirmationModal(false);

    const currentMatch = properties[currentPropertyIndex];
    const matchId = currentMatch.id;
    const offerPropertyId = currentMatch.offerPropertyId || currentMatch.Property?.id;

    try {
      const response = await authFetch(
        `${BASE_URL}/property/matching/updateMatchStatus`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: matchId,
            offerPropertyId: offerPropertyId,
            status: "accepted",
          }),
        },
      );

      if (response.ok) {
        console.log("Match status updated to 'accepted' successfully.");
        
        // Remove the current property from the list
        const updatedProperties = properties.filter(
          (match, index) => index !== currentPropertyIndex
        );
        setProperties(updatedProperties);

        let newIndex = currentPropertyIndex;
        if (newIndex >= updatedProperties.length) {
          newIndex = Math.max(0, updatedProperties.length - 1);
        }
        setCurrentPropertyIndex(newIndex);
        
        navigate(`/EditOrView/${currentMatch.Property.id}`, {
          state: { fromDiscoverMore: true },
        });
      } else {
        const errorData = await response.json();
        console.error(
          "Failed to update match status to 'accepted':",
          errorData.message || response.statusText,
        );
        console.log(
          t("Failed_To_Load") +
            ": " +
            (errorData.message || t("Error_Fetching_Properties")),
        );
      }
    } catch (error) {
      console.error("Error updating match status for 'accepted':", error);
      console.log(t("Error_Fetching_Properties"));
    }
  };

  const cancelDiscoverMore = () => {
    setShowConfirmationModal(false);
  };

  const languages = [
    { code: "en", name: t("language_en"), flag: ukFlag },
    { code: "it", name: t("language_it"), flag: itFlag },
    { code: "fr", name: t("language_fr"), flag: frFlag },
    { code: "de", name: t("language_de"), flag: deFlag },
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setShowLanguageDropdown(false);
  };

  const currentFlag =
    languages.find((lang) => lang.code === i18n.language)?.flag || ukFlag;

  const getButtonImage = (buttonType, language) => {
    switch (language) {
      case "it":
        return buttonType === "offer" ? OfferIt : SearchIt;
      case "fr":
        return buttonType === "offer" ? OfferFr : SearchFr;
      case "de":
        return buttonType === "offer" ? OfferDe : SearchDe;
      default: // 'en'
        return buttonType === "offer" ? OfferEn : SearchEn;
    }
  };

  const getFreeRegImage = (language) => {
    switch (language) {
      case "it":
        return FreeRegIt;
      case "fr":
        return FreeRegFr;
      case "de":
        return FreeRegDe;
      default: // 'en'
        return FreeRegEn;
    }
  };

  const handleSkip = async () => {
    if (properties.length === 0) return;

    const currentMatch = properties[currentPropertyIndex];
    const matchId = currentMatch.id;
    const offerPropertyId = currentMatch.offerPropertyId || currentMatch.Property?.id;

    // Check if this is a low-matching property (all-offers fallback, no matching record)
    // Bypass properties (within 20 KM, below threshold) have a real matchPercentage and should be permanently skippable
    const isLowMatchingProperty = currentMatch.id === null;

    // Trigger slide-out animation
    setIsSkipping(true);

    // Wait for animation to complete before updating state
    setTimeout(async () => {
      try {
        // For LOW-MATCHING properties: Just cycle through without API call (temporary skip)
        if (isLowMatchingProperty) {
          console.log("Skipping low-matching property (temporary, will cycle back)");

          // Just move to next property (cycle back to start if at end)
          let newIndex = currentPropertyIndex + 1;
          if (newIndex >= properties.length) {
            newIndex = 0; // Loop back to start
          }
          setCurrentPropertyIndex(newIndex);
          setIsSkipping(false);
          return; // Don't call API for low-matching properties
        }

        // For ALGORITHMIC MATCHES: Permanent skip (call API)
        console.log("Skipping algorithmic match (permanent)");
        const response = await authFetch(
          `${BASE_URL}/property/matching/updateMatchStatus`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: matchId,
              offerPropertyId: offerPropertyId,
              status: "skipped",
            }),
          },
        );

        if (response.ok) {
          console.log("Match status updated to 'skipped' successfully.");

          // Remove the current property from the list (filter by offerPropertyId instead of id)
          const updatedProperties = properties.filter(
            (match, index) => index !== currentPropertyIndex
          );

          // If all properties are skipped, refetch from API to loop back to start
          if (updatedProperties.length === 0) {
            console.log(
              "All properties skipped. Refetching properties to loop back to start.",
            );
            setProperties([]);
            setCurrentPropertyIndex(0);
            // Refetch properties from API
            await fetchProperties();
          } else {
            setProperties(updatedProperties);

            // Stay at the same index (which now shows the next property)
            let newIndex = currentPropertyIndex;
            if (newIndex >= updatedProperties.length) {
              newIndex = 0; // Loop back to start
            }
            setCurrentPropertyIndex(newIndex);
          }

          // Reset animation state to trigger slide-in for new property
          setIsSkipping(false);
        } else {
          const errorData = await response.json();
          console.error(
            "Failed to update match status to 'skipped':",
            errorData.message || response.statusText,
          );
          alert(
            t("Failed_To_Load") +
              ": " +
              (errorData.message || t("Error_Fetching_Properties")),
          );
          setIsSkipping(false);
        }
      } catch (error) {
        console.error("Error updating match status for 'skipped':", error);
        alert(t("Error_Fetching_Properties"));
        setIsSkipping(false);
      }
    }, 300); // Match animation duration
  };

  const handleImageSlider = (direction) => {
    if (properties.length === 0) return;

    const currentImages =
      properties[currentPropertyIndex].Property.PropertyShowcase.images;
    if (!currentImages || currentImages.length === 0) return;

    const currentMainImageIndex = currentImages.indexOf(mainDisplayImage);
    let newIndex = currentMainImageIndex;

    if (direction === "left") {
      newIndex =
        currentMainImageIndex === 0
          ? currentImages.length - 1
          : currentMainImageIndex - 1;
    } else {
      // 'right'
      newIndex =
        currentMainImageIndex === currentImages.length - 1
          ? 0
          : currentMainImageIndex + 1;
    }
    setMainDisplayImage(currentImages[newIndex]);
  };

  const isOfferDisabled = isAuthenticated && currentFlow === "demand";
  const isSearchDisabled = isAuthenticated && currentFlow === "offer";

  const handleDisabledClick = (e, message) => {
    if (e) e.preventDefault();
    console.log(message);
  };
  const slickRef = useRef(null);

  if (!loadingAuth && isAuthenticated && currentUser) {
    // Case 1: Authenticated 'demand' user - show matching properties dashboard
    if (currentUser.userType === "demand") {
      let rightPanelContent;
      console.log(properties, "properties");
      if (loadingProperties) {
        rightPanelContent = (
          <LoadingMessage>{t("Loading_Properties")}</LoadingMessage>
        );
      } else if (error) {
        rightPanelContent = (
          <NoPropertiesMessage>
            {t("Error")}: {error}
          </NoPropertiesMessage>
        );
      } else if (properties.length === 0) {
        rightPanelContent = (
          <NoPropertiesMessage>{t("No_Properties_Found")}</NoPropertiesMessage>
        );
      } else {
        const currentProperty = properties[currentPropertyIndex];
        const propertyData = currentProperty.Property;
        const address = propertyData.PropertyAddresses[0];
        const showcase = propertyData.PropertyShowcase;
        const user = propertyData.User;

        rightPanelContent = (
          <>
            {/* Show low matching message if match percentage exists and is less than 40% */}
            {currentProperty.matchPercentage == null &&
             currentProperty.matchPercentage == undefined &&
             currentProperty.matchPercentage < 40 && (
              <LowMatchingBanner>{t("low_matching_message")}</LowMatchingBanner>
            )}
            <PropertyCardWrapper $isSkipping={isSkipping}>
              <MainImageContainer>
              {/* Main Image */}
              <MainImage
                src={mainDisplayImage}
                alt={t("Main_Property")}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://placehold.co/800x400/EEEEEE/333333?text=" +
                    t("Image_Not_Available");
                }}
              />

              {/* Carousel Navigation Buttons */}
              {properties[currentPropertyIndex]?.Property?.PropertyShowcase
                ?.images?.length > 1 && (
                <>
                  <ImageNavButton
                    className="left"
                    onClick={() => handleImageSlider("left")}
                  >
                    <ImageNavIcon src={ChevronLeftIcon} alt={t("Previous")} />
                  </ImageNavButton>
                  <ImageNavButton
                    className="right"
                    onClick={() => handleImageSlider("right")}
                  >
                    <ImageNavIcon src={ChevronRightIcon} alt={t("Next")} />
                  </ImageNavButton>
                </>
              )}

              {/* Dot Indicators */}
              {properties[currentPropertyIndex]?.Property?.PropertyShowcase
                ?.images?.length > 1 && (
                <DotIndicatorContainer>
                  {properties[
                    currentPropertyIndex
                  ].Property.PropertyShowcase.images.map((imgUrl, index) => (
                    <DotIndicator
                      key={index}
                      $active={mainDisplayImage === imgUrl}
                      onClick={() => setMainDisplayImage(imgUrl)}
                    />
                  ))}
                </DotIndicatorContainer>
              )}
            </MainImageContainer>

            {/* <ThumbnailsCarouselWrapper>
              <ThumbnailsContainer>
                {showcase.images && showcase.images.length > 1 && (
                  <>
                    <ImageNavButton className="left" onClick={() => handleImageSlider('left')}>
                      <ImageNavIcon src={ChevronLeftIcon} alt={t('Previous')} />
                    </ImageNavButton>
                    <ImageNavButton className="right" onClick={() => handleImageSlider('right')}>
                      <ImageNavIcon src={ChevronRightIcon} alt={t('Next')} />
                    </ImageNavButton>
                  </>
                )}
                {showcase.images.map((imgUrl, index) => (
                  <ThumbnailImageWrapper
                    key={index}
                    $active={mainDisplayImage === imgUrl}
                    onClick={() => setMainDisplayImage(imgUrl)}
                  >
                    <ThumbnailImage
                      src={imgUrl}
                      alt={t('Image')}
                      onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/80x80/CCCCCC/666666?text=X'; }}
                    />
                  </ThumbnailImageWrapper>
                ))}

              </ThumbnailsContainer>
            </ThumbnailsCarouselWrapper> */}

            <PropertyDetailsGrid>
              <DetailItem>
                <DetailLabel>{t("zip")}</DetailLabel>
              </DetailItem>
              <DetailItem>
                <DetailLabel>{t("city")}</DetailLabel>
              </DetailItem>
              <DetailItem>
                <DetailLabel>{t("Type")}</DetailLabel>
              </DetailItem>
              <DetailItem>
                <DetailLabel>{t("Sqm")}</DetailLabel>
              </DetailItem>
              <DetailItem>
                <DetailLabel>{getRoomLabel(propertyData.propertyType)}</DetailLabel>
              </DetailItem>
              <DetailItem>
                <DetailLabel>{t("Budget")}</DetailLabel>
              </DetailItem>
            </PropertyDetailsGrid>

            <PropertyDetailsGrid2>
              <DetailItem>
                <DetailValue>{address.zipCode}</DetailValue>
              </DetailItem>
              <DetailItem>
                <DetailValue>{address.city}</DetailValue>
              </DetailItem>
              <DetailItem>
                <DetailValue>{propertyData.propertyType}</DetailValue>
              </DetailItem>
              <DetailItem>
                <DetailValue>{propertyData.squareMeters}</DetailValue>
              </DetailItem>
              <DetailItem>
                <DetailValue>
                  {getRoomValue(propertyData.propertyType, propertyData.bedrooms, propertyData.units, propertyData.index)}
                </DetailValue>
              </DetailItem>
              <DetailItem>
                <DetailValue>
                  {propertyData.price ? formatWithApostrophe(propertyData.price) : '-'} {propertyData.currency}
                </DetailValue>
              </DetailItem>
            </PropertyDetailsGrid2>

            {/* Show matching section for all algorithmic matches (any matchPercentage), title/description for all-offers fallback */}
            {currentProperty.matchPercentage !== null &&
             currentProperty.matchPercentage !== undefined ? (
              <MatchScoreSection>
                <ScoreColumn>
                  <MainScoreLabel>{t("Matching")}</MainScoreLabel>
                  <CriteriaLabel>{t("Must_Criteria")}</CriteriaLabel>
                  <CriteriaLabel>{t("Nice_To_Have")}</CriteriaLabel>
                  {currentProperty.distance && parseFloat(currentProperty.distance) > 0 && (
                    <CriteriaLabel>{t("Distance")}</CriteriaLabel>
                  )}
                </ScoreColumn>
                <ScoreColumn style={{ textAlign: "right" }}>
                  <MatchPercentageValue>
                    {currentProperty.matchPercentage}%
                  </MatchPercentageValue>
                  <CriteriaScoreValue>
                    {currentProperty.mustCriteriaValueScore || '—'}
                  </CriteriaScoreValue>
                  <CriteriaScoreValue>
                    {currentProperty.shouldCriteriaValueScore || '—'}
                  </CriteriaScoreValue>
                  {currentProperty.distance && parseFloat(currentProperty.distance) > 0 && (
                    <CriteriaScoreValue>
                      {parseFloat(currentProperty.distance).toFixed(1)} km
                    </CriteriaScoreValue>
                  )}
                </ScoreColumn>
              </MatchScoreSection>
            ) : (
              // For all other properties (no match percentage or < 40%), show property info
              <LowMatchingInfoSection>
                {propertyData.propertyTitle && (
                  <>
                    <LowMatchingHeading>
                      {t("property_title")}
                    </LowMatchingHeading>
                    <LowMatchingValue>
                      {propertyData.propertyTitle}
                    </LowMatchingValue>
                  </>
                )}
            {propertyData.description && (
              <DescriptionSection>
                <LowMatchingHeading>
                  {t("description_label")}
                </LowMatchingHeading>
                <LowMatchingValue>
                  {isDescriptionExpanded || propertyData.description.length <= 100
                    ? propertyData.description
                    : `${propertyData.description.substring(0, 100)}...`}
                  {propertyData.description.length > 100 && (
                    <ShowMoreButton onClick={() => setIsDescriptionExpanded(!isDescriptionExpanded)}>
                      {isDescriptionExpanded ? t("Show_Less") : t("Show_More")}
                    </ShowMoreButton>
                  )}
                </LowMatchingValue>
              </DescriptionSection>
            )}
              </LowMatchingInfoSection>
              
            )}

            <FooterActionsContainer>
              <ActionButton $secondary onClick={handleSkip}>
                <ActionButtonIcon src={TrashXmarkIcon} alt={t("Skip")} $color="red" />
                <ActionButtonText>{t("Skip")}</ActionButtonText>
              </ActionButton>
              <UserTypeBadge>
                {user.isPrivate ? t("PRIVATE_INDIVIDUAL") : t("COMPANY_AGENCY")}
              </UserTypeBadge>
              <ActionButton $primary onClick={handleDiscoverMore}>
                <ActionButtonIcon src={thumbsup} alt={t("Discover_More")} $color="green" />
                <ActionButtonText>{t("Discover_More")}</ActionButtonText>
              </ActionButton>
            </FooterActionsContainer>
          </PropertyCardWrapper>
          </>
        );
      }

      return (
        <DemandDashboardContainer>
          {/* LEFT PANEL: Trending Properties for Demand Users - matching SearchProperty.js */}
          <TrendingLeftPanel>
            {!isLoading && !error && demands.length > 0 && (
              <NewSearchesHeader>
                <NewSearchesTitle>{t("new_demands")}</NewSearchesTitle>
              </NewSearchesHeader>
            )}
            {demands.length > 0 && (
              <PropertyList>
                <NewOffersSwiper items={demands} className="mySwiper" />
              </PropertyList>
            )}
          </TrendingLeftPanel>

          <MatchingPropertiesContainer>
            {rightPanelContent}
          </MatchingPropertiesContainer>

          {showConfirmationModal && (
            <ModalOverlay>
              <ModalContent>
                <ModalMessage>
                  {t(
                    "Do you want to view the details? Once confirmed, your information will be shared with the property owner.",
                  )}
                </ModalMessage>
                <ModalButtonContainer>
                  <ModalButton className="cancel" onClick={cancelDiscoverMore}>
                    {t("Cancel")}
                  </ModalButton>
                  <ModalButton
                    className="confirm"
                    onClick={confirmDiscoverMore}
                  >
                    {t("Confirm")}
                  </ModalButton>
                </ModalButtonContainer>
              </ModalContent>
            </ModalOverlay>
          )}
        </DemandDashboardContainer>
      );
    }
    // Case 2: Authenticated 'offer' user - show MyProperties page
    else if (currentUser.userType === "offer") {
      // NEW LOGIC ADDED HERE:
      // If the 'offer' user is NOT subscribed, show them the marketing page.
      if (currentUser.isSubscribed === false) {
        // Fall through to the final return, which is the marketing page.
        // This is a cleaner way than duplicating the JSX.
      } else {
        // If the 'offer' user IS subscribed, show them their properties.
        return <MyProperties />;
      }
    }
  }

  // Case 3: Unauthenticated user (or any other userType not explicitly handled above)
  // This part of the code remains unchanged for the marketing page
  return (
    <>
      <ShadeGlobalStyle />
      <BackgroundWrapper>
        <PageBackground>
        </PageBackground>

        <HomeContainer id="homepagezoom">
          <ContentOverlay>
            <LeftPanel style={{ textAlign: "justify" }}>
              <BrandMain />
              <Headline>{t("Headline")}</Headline>
              <Subheadline>{t("Subheadline")}</Subheadline>
              <Description>{t("Description1")}</Description>
              <Highlight>{t("Highlight1")}</Highlight>
              <Description>{t("Description2")}</Description>
              <Brand>{t("HowItWorks")}</Brand>
              <div>
                <div>
                  <Highlight>{t("HowItWorks_item1_highlight")}</Highlight>
                  <Description>{t("HowItWorks_item1_description")}</Description>
                </div>
                <div>
                  <Highlight>{t("HowItWorks_item2_highlight")}</Highlight>
                  <Description>{t("HowItWorks_item2_description")}</Description>
                </div>
                <div>
                  <Highlight>{t("HowItWorks_item3_highlight")}</Highlight>
                  <Description>{t("HowItWorks_item3_description")}</Description>
                </div>
                <div>
                  <Highlight>{t("HowItWorks_item4_highlight")}</Highlight>
                  <Description>
                    {t("HowItWorks_item4_description_part1")}{" "}
                    <SearchCasaBrand />
                    {t("HowItWorks_item4_description_part2")}{" "}
                    <SearchCasaBrand />
                    {t("HowItWorks_item4_description_part3")}
                  </Description>
                </div>
              </div>
              <Brand>{t("AdvantagesOfSearchCasa")}</Brand>
              <Brand>{t("ForHomeSeekers")}</Brand>
              <div>
                <div>
                  <Highlight>{t("ForHomeSeekers_item1_highlight")}</Highlight>
                  <Description>
                    {t("ForHomeSeekers_item1_description")}
                  </Description>
                </div>
                <div>
                  <Highlight>{t("ForHomeSeekers_item2_highlight")}</Highlight>
                  <Description>
                    {t("ForHomeSeekers_item2_description")}
                  </Description>
                </div>
                <div>
                  <Highlight>{t("ForHomeSeekers_item3_highlight")}</Highlight>
                  <Description>
                    {t("ForHomeSeekers_item3_description")}
                  </Description>
                </div>
                <div>
                  <Highlight>{t("ForHomeSeekers_item4_highlight")}</Highlight>
                  <Description>
                    {t("ForHomeSeekers_item4_description")}
                  </Description>
                </div>
              </div>
              <Brand>{t("ForOwners")}</Brand>
              <div>
                <div>
                  <Highlight>{t("ForOwners_item1_highlight")}</Highlight>
                  <Description>{t("ForOwners_item1_description")}</Description>
                </div>
                <div>
                  <Highlight>{t("ForOwners_item2_highlight")}</Highlight>
                  <Description>{t("ForOwners_item2_description")}</Description>
                </div>
                <div>
                  <Highlight>{t("ForOwners_item3_highlight")}</Highlight>
                  <Description>{t("ForOwners_item3_description")}</Description>
                </div>
                <div>
                  <Highlight>{t("ForOwners_item4_highlight")}</Highlight>
                  <Description>{t("ForOwners_item4_description")}</Description>
                </div>
                <div>
                  <Highlight>{t("ForOwners_item5_highlight")}</Highlight>
                  <Description>{t("ForOwners_item5_description")}</Description>
                </div>
              </div>
              <Description>
                {t("ClosingDescription_part1")}{" "}
                <SearchCasaBrand />
                {t("ClosingDescription_part2")}
              </Description>
              <div>
                <Highlight>{t("CallToAction_highlight")}</Highlight>
                <Description>
                  <SearchCasaHighlight>
                    {t("CallToAction_description_part1")}
                  </SearchCasaHighlight>
                  {t("CallToAction_description_part2")}{" "}
                  <SearchCasaBrand />
                  {t("CallToAction_description_part3")}
                </Description>
              </div>
            </LeftPanel>

            <RightPanel>
              <BackgroundSliderWrapper>
                <Swiper
                  effect="fade"
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  modules={[Autoplay, EffectFade]}
                  loop={true}
                  style={{ width: "100%", height: "100%" }}
                >
                  {images.map((image, index) => (
                    <SwiperSlide key={index}>
                      <HandshakeBackground
                        src={image}
                        alt={`Background ${index + 1}`}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </BackgroundSliderWrapper>

              <TopRightControls>
                <DropdownLinkItem to="/auth/login?mode=login">
                  {t("login")}
                </DropdownLinkItem>
                <div
                  ref={languageDropdownRef}
                  onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}
                >
                  <LanguageVisual>
                    <FlagIcon src={currentFlag} alt={`${i18n.language} Flag`} />
                    <span>{i18n.language.split("-")[0].toUpperCase()}</span>
                    <span>&#9660;</span>
                  </LanguageVisual>

                  <CombinedDropdownContent $isOpen={showLanguageDropdown}>
                    {languages.map((lang) => (
                      <DropdownItem
                        key={lang.code}
                        onClick={(e) => {
                          e.stopPropagation();
                          changeLanguage(lang.code);
                        }}
                      >
                        <FlagIcon src={lang.flag} alt={`${lang.name} Flag`} />
                        <span>{lang.name}</span>
                      </DropdownItem>
                    ))}
                  </CombinedDropdownContent>
                </div>
              </TopRightControls>
              <LogoSectionMain>
                <Logo2 src={iconMain} alt="search.casa logo" />
              </LogoSectionMain>
              <LogoSection>
                <Logo src={icon} alt="search.casa logo" />
              </LogoSection>

              <FreeRegImage
                src={getFreeRegImage(currentLanguage)}
                alt={t("Free_Registrations")}
              />

              <CTASection>
                {/* Offer A Property Button */}
                <div style={{ position: "relative" }}>
                  <CTAButton
                    to={isOfferDisabled ? "#" : "/OfferProperty"}
                    onClick={
                      isOfferDisabled
                        ? (e) =>
                            handleDisabledClick(
                              e,
                              t("Log out first to offer a property."),
                            )
                        : null
                    }
                    onMouseEnter={() =>
                      isOfferDisabled && setShowOfferTooltip(true)
                    }
                    onMouseLeave={() => setShowOfferTooltip(false)}
                    $disabled={isOfferDisabled}
                  >
                    <ButtonImage
                      src={getButtonImage("offer", currentLanguage)}
                      alt={t("offer_property")}
                    />
                  </CTAButton>
                  {showOfferTooltip && isOfferDisabled && (
                    <Tooltip>{t("Log out first to offer a property.")}</Tooltip>
                  )}
                </div>

                {/* Search a Property Button */}
                <div style={{ position: "relative" }}>
                  <CTAButton
                    to={isSearchDisabled ? "#" : "/SearchProperty"}
                    onClick={
                      isSearchDisabled
                        ? (e) =>
                            handleDisabledClick(
                              e,
                              t("Log out first to search for a property."),
                            )
                        : null
                    }
                    onMouseEnter={() =>
                      isSearchDisabled && setShowSearchTooltip(true)
                    }
                    onMouseLeave={() => setShowSearchTooltip(false)}
                    $disabled={isSearchDisabled}
                  >
                    <ButtonImage
                      src={getButtonImage("search", currentLanguage)}
                      alt={t("Search_Property")}
                    />
                  </CTAButton>
                  {showSearchTooltip && isSearchDisabled && (
                    <Tooltip>
                      {t("Log out first to search for a property.")}
                    </Tooltip>
                  )}
                </div>
              </CTASection>
            </RightPanel>
          </ContentOverlay>
        </HomeContainer>
      </BackgroundWrapper>
    </>
  );
};

export default Home;
